import { render } from "./TouchTableEntity.vue?vue&type=template&id=bbf79f6c&scoped=true&ts=true"
import script from "./TouchTableEntity.vue?vue&type=script&lang=ts"
export * from "./TouchTableEntity.vue?vue&type=script&lang=ts"

import "./TouchTableEntity.vue?vue&type=style&index=0&id=bbf79f6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf79f6c"]])

export default __exports__